import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import CronTasksList from './CronTasksList/CronTasksList';
import CronTaskEdit from './CronTaskEdit/CronTaskEdit';
import CronTaskCreate from './CronTaskCreate/CronTaskCreate';
import CronTaskDelete from './CronTaskDelete/CronTaskDelete';

const CronTasks = ({ match }) => {
    return (
        <div className="CronTasks">
            <ContainerWrapper container="cron_tasks">
                <Route exact path={ match.path } component={CronTasksList} />
                <Route exact path={ `${ match.url }/new` } component={CronTaskCreate} />
                <Route exact path={ `${ match.url }/edit/:cron_taskId` } component={CronTaskEdit} />
                <Route exact path={ `${ match.url }/delete/:cron_taskId` } component={CronTaskDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default CronTasks;
